(function () {
  'use strict';

  function initCategDrawer() {
    const drawer = document.querySelector('[data-categ-drawer]');
    const closeBtn = document.querySelector('[data-categ-close]');
    const overlay = document.querySelector('[data-categ-overlay]');
    const switchBtns = document.querySelectorAll('[data-switch-btn]');
    const switchPanels = document.querySelectorAll('[data-switch-panel]');
    const desktopTrigger = document.querySelector('[data-categories-trigger]');
    const mobileTrigger = document.querySelector('[data-mobile-menu-trigger]');

    if (!drawer) return;

    function getItems() {
      return drawer.querySelectorAll('[data-categ-item]');
    }

    function resetOuterButtons() {
      if (desktopTrigger) {
        desktopTrigger.classList.remove('active', 'is-active');
        desktopTrigger.setAttribute('aria-expanded', 'false');
      }

      if (mobileTrigger) {
        mobileTrigger.classList.remove('active', 'is-active');
        mobileTrigger.setAttribute('aria-expanded', 'false');
      }
    }

    function setOuterButtonsOpen() {
      if (window.innerWidth <= 768) {
        if (mobileTrigger) {
          mobileTrigger.classList.add('active');
          mobileTrigger.setAttribute('aria-expanded', 'true');
        }
        if (desktopTrigger) {
          desktopTrigger.classList.remove('active', 'is-active');
          desktopTrigger.setAttribute('aria-expanded', 'false');
        }
      } else {
        if (desktopTrigger) {
          desktopTrigger.classList.add('active');
          desktopTrigger.setAttribute('aria-expanded', 'true');
        }
        if (mobileTrigger) {
          mobileTrigger.classList.remove('active', 'is-active');
          mobileTrigger.setAttribute('aria-expanded', 'false');
        }
      }
    }

    function closeAllSubmenus() {
      getItems().forEach(function (item) {
        item.classList.remove('qn-categ-drawer__item--open');
      });
    }

    function toggleItem(item) {
      if (!item) return;

      const isOpen = item.classList.contains('qn-categ-drawer__item--open');
      const parent = item.parentElement;

      if (parent) {
        parent.querySelectorAll(':scope > [data-categ-item]').forEach(function (otherItem) {
          if (otherItem !== item) {
            otherItem.classList.remove('qn-categ-drawer__item--open');
          }
        });
      }

      item.classList.toggle('qn-categ-drawer__item--open', !isOpen);
    }

    function changePanel(target) {
      if (!target) return;

      switchBtns.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-target') === target);
      });

      switchPanels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-switch-panel') === target);
      });

      closeAllSubmenus();
    }

    function setInitialPanel() {
      changePanel('categorias');
    }

    function openDrawer(forcePanel) {
      drawer.classList.add('qn-categ-drawer--open', 'active');
      drawer.setAttribute('aria-hidden', 'false');

      if (overlay) {
        overlay.classList.add('active');
        overlay.setAttribute('aria-hidden', 'false');
      }

      document.body.classList.add('overflow-hidden');

      if (window.innerWidth <= 768) {
        if (forcePanel === 'menu' || forcePanel === 'categorias') {
          changePanel(forcePanel);
        } else {
          changePanel('categorias');
        }
      } else {
        changePanel('categorias');
      }

      setOuterButtonsOpen();
    }

    function closeDrawer() {
      drawer.classList.remove('qn-categ-drawer--open', 'active');
      drawer.setAttribute('aria-hidden', 'true');

      if (overlay) {
        overlay.classList.remove('active');
        overlay.setAttribute('aria-hidden', 'true');
      }

      document.body.classList.remove('overflow-hidden');
      closeAllSubmenus();
      resetOuterButtons();
    }

    switchBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        changePanel(this.getAttribute('data-target'));
      });
    });

    if (desktopTrigger) {
      desktopTrigger.addEventListener('click', function (e) {
        e.preventDefault();

        const isOpen = drawer.getAttribute('aria-hidden') === 'false';
        if (isOpen) {
          closeDrawer();
        } else {
          openDrawer('categorias');
        }
      });
    }

    if (mobileTrigger) {
      mobileTrigger.addEventListener('click', function (e) {
        e.preventDefault();

        const isOpen = drawer.getAttribute('aria-hidden') === 'false';
        if (isOpen) {
          closeDrawer();
        } else {
          openDrawer('menu');
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }

    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeDrawer();
      }
    });

    window.addEventListener('resize', function () {
      if (drawer.getAttribute('aria-hidden') === 'false') {
        if (window.innerWidth <= 768) {
          const activeBtn = drawer.querySelector('.qn-categ-drawer__switch-btn.is-active');
          if (activeBtn) {
            changePanel(activeBtn.getAttribute('data-target'));
          } else {
            changePanel('categorias');
          }
        } else {
          changePanel('categorias');
        }
      }
    });

    drawer.addEventListener('click', function (e) {
      const row = e.target.closest('.qn-categ-drawer__parent, .qn-categ-drawer__subparent');
      if (!row) return;

      const item = row.closest('[data-categ-item]');
      if (!item) return;

      const hasChildren =
        item.classList.contains('qn-categ-drawer__item--has-children') ||
        item.classList.contains('qn-categ-drawer__subitem--has-children') ||
        !!item.querySelector(':scope > .qn-categ-drawer__submenu');

      if (!hasChildren) return;

      e.preventDefault();
      e.stopPropagation();
      toggleItem(item);
    });

    setInitialPanel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategDrawer);
  } else {
    initCategDrawer();
  }
})();